import type {
  MarkingPortalCheckInParams,
  MarkingPortalCheckInResult,
} from '@src/models/interfaces/markingPortal.interface';
import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

class MarkingPortalRepository {
  async checkIn(params: MarkingPortalCheckInParams): Promise<MarkingPortalCheckInResult> {
    const checkInFn = apiCallable<MarkingPortalCheckInParams, MarkingPortalCheckInResult>(
      API_OPERATIONS.MARKING_PORTAL_CHECKIN,
    );
    const response = await checkInFn(params);
    return response.data;
  }
}

export default MarkingPortalRepository;
